import { cn } from '../../../../utils/cn';
import styles from './Switch.module.css';

export interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  ariaLabel: string;
  disabled?: boolean;
  /** Visible text rendered next to the track. */
  label?: string;
}

export function Switch({
  checked,
  onChange,
  ariaLabel,
  disabled = false,
  label,
}: SwitchProps): JSX.Element {
  return (
    <label className={cn(styles.wrap, disabled ? styles.disabled : null)}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={cn(styles.track, checked ? styles.on : styles.off)}
      >
        <span className={styles.thumb} aria-hidden />
      </button>
      {label !== undefined ? <span className={styles.label}>{label}</span> : null}
    </label>
  );
}
